import React, {PropsWithChildren, useContext, useEffect} from 'react';
import {StepperContext} from '../stepper-context';
import {StepContentContext, StepContentContextValue} from './step-content-context';
import styles from './styles.module.less';
import {join} from '../../../utils/join';

type Props = {
	index: number;
	disabled?: boolean;
} & PropsWithChildren;

export function Step(props: Props) {
	const context = useContext(StepperContext);
	const isActive = context.activeStep === props.index;

	useEffect(() => {
		context.addStep(props.index);
		return () => context.removeStep(props.index);
	}, [props.index]);

	const contextValue = {active: isActive, disabled: props.disabled, index: props.index} as StepContentContextValue;

	return <div className={join(styles.step, !isActive && styles.notActiveStep, !isActive && !contextValue.disabled && styles.stepDisabled, props.disabled && styles.disabled)}>
		<StepContentContext.Provider value={contextValue}>
			{props.children}
		</StepContentContext.Provider>
	</div>;
}
